import type { OrganizationTabCode, UserContextResponse } from "./types";

export function tabAccess(context: UserContextResponse | null | undefined, tabCode: OrganizationTabCode) {
  const secureByDefault = tabCode === "CRM" || tabCode === "SETTINGS" || tabCode === "DUTY_STATUS";
  return context?.tab_permissions?.find((permission) => permission.tab_code === tabCode) ?? {
    tab_code: tabCode,
    label: tabCode,
    can_view: !secureByDefault,
    can_update: !secureByDefault
  };
}
